import { cn } from '@/lib/utils';
import AdditionalWork from '@/public/img/icons/custom/additional-work.svg';
import BarChart from '@/public/img/icons/custom/bar-chart.svg';
import CalendarDk from '@/public/img/icons/custom/calendar.svg';
import Camera from '@/public/img/icons/custom/camera.svg';
import CellsAndHouse from '@/public/img/icons/custom/cells-and-house.svg';
import Computer from '@/public/img/icons/custom/computer.svg';
import Customers from '@/public/img/icons/custom/customers.svg';
import Document from '@/public/img/icons/custom/document.svg';
import DotsVertical from '@/public/img/icons/custom/dots-vertical.svg';
import Factory from '@/public/img/icons/custom/factory.svg';
import Inverter from '@/public/img/icons/custom/inverter.svg';
import Lightning from '@/public/img/icons/custom/lightning.svg';
import Loading from '@/public/img/icons/custom/loading.svg';
import MoneyLoss from '@/public/img/icons/custom/money-loss.svg';
import MoneyProfit from '@/public/img/icons/custom/money-profit.svg';
import NavGrid from '@/public/img/icons/custom/nav-grid.svg';
import Pin from '@/public/img/icons/custom/pin.svg';
import Plug from '@/public/img/icons/custom/plug.svg';
import RefreshTwo from '@/public/img/icons/custom/refresh-two.svg';
import SelfSufficiency from '@/public/img/icons/custom/self-sufficiency.svg';
import SettingsAlt from '@/public/img/icons/custom/settings-alt.svg';
import Star from '@/public/img/icons/custom/star.svg';
import Support from '@/public/img/icons/custom/support.svg';
import Tree from '@/public/img/icons/custom/tree.svg';
import User from '@/public/img/icons/custom/user.svg';
import Van from '@/public/img/icons/custom/van.svg';
import Airconditioner from '@/public/img/icons/harmonized/airconditioner.svg';
import AlertCircleFilled from '@/public/img/icons/harmonized/alert-circle-filled.svg';
import AlertCircle from '@/public/img/icons/harmonized/alert-circle.svg';
import AlertTriangleFilled from '@/public/img/icons/harmonized/alert-triangle-filled.svg';
import AlertTriangle from '@/public/img/icons/harmonized/alert-triangle.svg';
import ArrowCircleDownFilled from '@/public/img/icons/harmonized/arrow-circle-down-filled.svg';
import ArrowCircleDown from '@/public/img/icons/harmonized/arrow-circle-down.svg';
import ArrowCircleLeftFilled from '@/public/img/icons/harmonized/arrow-circle-left-filled.svg';
import ArrowCircleLeft from '@/public/img/icons/harmonized/arrow-circle-left.svg';
import ArrowCircleRightFilled from '@/public/img/icons/harmonized/arrow-circle-right-filled.svg';
import ArrowCircleRight from '@/public/img/icons/harmonized/arrow-circle-right.svg';
import ArrowCircleUpFilled from '@/public/img/icons/harmonized/arrow-circle-up-filled.svg';
import ArrowCircleUp from '@/public/img/icons/harmonized/arrow-circle-up.svg';
import ArrowLeft from '@/public/img/icons/harmonized/arrow-left.svg';
import ArrowRight from '@/public/img/icons/harmonized/arrow-right.svg';
import BatteryChargingFilled from '@/public/img/icons/harmonized/battery-charging-filled.svg';
import BatteryCharging from '@/public/img/icons/harmonized/battery-charging.svg';
import BatteryEmptyFilled from '@/public/img/icons/harmonized/battery-empty-filled.svg';
import BatteryEmpty from '@/public/img/icons/harmonized/battery-empty.svg';
import BatteryFullFilled from '@/public/img/icons/harmonized/battery-full-filled.svg';
import BatteryFull from '@/public/img/icons/harmonized/battery-full.svg';
import BatteryLowFilled from '@/public/img/icons/harmonized/battery-low-filled.svg';
import BatteryLow from '@/public/img/icons/harmonized/battery-low.svg';
import BatteryMidFilled from '@/public/img/icons/harmonized/battery-mid-filled.svg';
import BatteryMid from '@/public/img/icons/harmonized/battery-mid.svg';
import BellFilled from '@/public/img/icons/harmonized/bell-filled.svg';
import BellPlusFilled from '@/public/img/icons/harmonized/bell-plus-filled.svg';
import BellPlus from '@/public/img/icons/harmonized/bell-plus.svg';
import Bell from '@/public/img/icons/harmonized/bell.svg';
import CalendarFilled from '@/public/img/icons/harmonized/calendar-filled.svg';
import Calendar from '@/public/img/icons/harmonized/calendar.svg';
import CheckCircleFilled from '@/public/img/icons/harmonized/check-circle-filled.svg';
import CheckCircle from '@/public/img/icons/harmonized/check-circle.svg';
import CheckFilled from '@/public/img/icons/harmonized/check-filled.svg';
import Check from '@/public/img/icons/harmonized/check.svg';
import ChevronDownFilled from '@/public/img/icons/harmonized/chevron-down-filled.svg';
import ChevronDown from '@/public/img/icons/harmonized/chevron-down.svg';
import ChevronLeftFilled from '@/public/img/icons/harmonized/chevron-left-filled.svg';
import ChevronLeft from '@/public/img/icons/harmonized/chevron-left.svg';
import ChevronRightFilled from '@/public/img/icons/harmonized/chevron-right-filled.svg';
import ChevronRight from '@/public/img/icons/harmonized/chevron-right.svg';
import ChevronSelectorVerticalFilled from '@/public/img/icons/harmonized/chevron-selector-vertical-filled.svg';
import ChevronSelectorVertical from '@/public/img/icons/harmonized/chevron-selector-vertical.svg';
import ChevronUpFilled from '@/public/img/icons/harmonized/chevron-up-filled.svg';
import ChevronUp from '@/public/img/icons/harmonized/chevron-up.svg';
import ClockFilled from '@/public/img/icons/harmonized/clock-filled.svg';
import Clock from '@/public/img/icons/harmonized/clock.svg';
import CloudFilled from '@/public/img/icons/harmonized/cloud-filled.svg';
import Cloud from '@/public/img/icons/harmonized/cloud.svg';
import CoinsStackedFilled from '@/public/img/icons/harmonized/coins-stacked-filled.svg';
import CoinsStacked from '@/public/img/icons/harmonized/coins-stacked.svg';
import CompareFilled from '@/public/img/icons/harmonized/compare-filled.svg';
import Compare from '@/public/img/icons/harmonized/compare.svg';
import CopyFilled from '@/public/img/icons/harmonized/copy-filled.svg';
import Copy from '@/public/img/icons/harmonized/copy.svg';
import DeveloperFilled from '@/public/img/icons/harmonized/developer-filled.svg';
import Developer from '@/public/img/icons/harmonized/developer.svg';
import Dot from '@/public/img/icons/harmonized/dot.svg';
import DownloadFilled from '@/public/img/icons/harmonized/download-filled.svg';
import Download from '@/public/img/icons/harmonized/download.svg';
import DrizzleFilled from '@/public/img/icons/harmonized/drizzle-filled.svg';
import Drizzle from '@/public/img/icons/harmonized/drizzle.svg';
import EditFilled from '@/public/img/icons/harmonized/edit-filled.svg';
import Edit from '@/public/img/icons/harmonized/edit.svg';
import EuroCircleFilled from '@/public/img/icons/harmonized/euro-circle-filled.svg';
import EuroCircle from '@/public/img/icons/harmonized/euro-circle.svg';
import EuroFilled from '@/public/img/icons/harmonized/euro-filled.svg';
import Euro from '@/public/img/icons/harmonized/euro.svg';
import EVFilled from '@/public/img/icons/harmonized/EV-filled.svg';
import EV from '@/public/img/icons/harmonized/EV.svg';
import EyeFilled from '@/public/img/icons/harmonized/eye-filled.svg';
import EyeOffFilled from '@/public/img/icons/harmonized/eye-off-filled.svg';
import EyeOff from '@/public/img/icons/harmonized/eye-off.svg';
import Eye from '@/public/img/icons/harmonized/eye.svg';
import FileCheckFilled from '@/public/img/icons/harmonized/file-check-filled.svg';
import FileCheck from '@/public/img/icons/harmonized/file-check.svg';
import FileSearchFilled from '@/public/img/icons/harmonized/file-search-filled.svg';
import FileSearch from '@/public/img/icons/harmonized/file-search.svg';
import FilterLinesFilled from '@/public/img/icons/harmonized/filter-lines-filled.svg';
import FilterLines from '@/public/img/icons/harmonized/filter-lines.svg';
import FoggyFilled from '@/public/img/icons/harmonized/foggy-filled.svg';
import Foggy from '@/public/img/icons/harmonized/foggy.svg';
import FreezingRainFilled from '@/public/img/icons/harmonized/freezing rain-filled.svg';
import FreezingRain from '@/public/img/icons/harmonized/freezing rain.svg';
import FullscreenExitFilled from '@/public/img/icons/harmonized/fullscreen-exit-filled.svg';
import FullscreenExit from '@/public/img/icons/harmonized/fullscreen-exit.svg';
import FullscreenFilled from '@/public/img/icons/harmonized/fullscreen-filled.svg';
import Fullscreen from '@/public/img/icons/harmonized/fullscreen.svg';
import GlobeFilled from '@/public/img/icons/harmonized/globe-filled.svg';
import Globe from '@/public/img/icons/harmonized/globe.svg';
import GrabberFilled from '@/public/img/icons/harmonized/grabber-filled.svg';
import Grabber from '@/public/img/icons/harmonized/grabber.svg';
import GridFilled from '@/public/img/icons/harmonized/grid-filled.svg';
import Grid from '@/public/img/icons/harmonized/grid.svg';
import HeartFilled from '@/public/img/icons/harmonized/heart-filled.svg';
import HeartHand from '@/public/img/icons/harmonized/heart-hand.svg';
import Heart from '@/public/img/icons/harmonized/heart.svg';
import HeartbeatAi from '@/public/img/icons/harmonized/heartbeat-ai.svg';
import HeartbeatFilled from '@/public/img/icons/harmonized/heartbeat-filled.svg';
import Heartbeat from '@/public/img/icons/harmonized/heartbeat.svg';
import HeatPump from '@/public/img/icons/harmonized/heat-pump.svg';
import HeatWaveFilled from '@/public/img/icons/harmonized/heat-wave-filled.svg';
import HeatWave from '@/public/img/icons/harmonized/heat-wave.svg';
import HelpCircleFilled from '@/public/img/icons/harmonized/help-circle-filled.svg';
import HelpCircle from '@/public/img/icons/harmonized/help-circle.svg';
import HomeLineFilled from '@/public/img/icons/harmonized/home-line-filled.svg';
import HomeLine from '@/public/img/icons/harmonized/home-line.svg';
import IconOutlined from '@/public/img/icons/harmonized/Icon Outlined.svg';
import InfoCircleFilled from '@/public/img/icons/harmonized/info-circle-filled.svg';
import InfoCircle from '@/public/img/icons/harmonized/info-circle.svg';
import LightCloudsNightFilled from '@/public/img/icons/harmonized/light-clouds-night-filled.svg';
import LightCloudsNight from '@/public/img/icons/harmonized/light-clouds-night.svg';
import LineChartUpFilled from '@/public/img/icons/harmonized/line-chart-up-filled.svg';
import LineChartUp from '@/public/img/icons/harmonized/line-chart-up.svg';
import LinkExternalFilled from '@/public/img/icons/harmonized/link-external-filled.svg';
import LinkExternal from '@/public/img/icons/harmonized/link-external.svg';
import LinkFilled from '@/public/img/icons/harmonized/link-filled.svg';
import Link from '@/public/img/icons/harmonized/link.svg';
import LogOutFilled from '@/public/img/icons/harmonized/log-out-filled.svg';
import LogOut from '@/public/img/icons/harmonized/log-out.svg';
import MailFilled from '@/public/img/icons/harmonized/mail-filled.svg';
import Mail from '@/public/img/icons/harmonized/mail.svg';
import MenuFilled from '@/public/img/icons/harmonized/menu-filled.svg';
import Menu from '@/public/img/icons/harmonized/menu.svg';
import MessageQuestionCircleFilled from '@/public/img/icons/harmonized/message-question-circle-filled.svg';
import MessageQuestionCircle from '@/public/img/icons/harmonized/message-question-circle.svg';
import MinusFilled from '@/public/img/icons/harmonized/minus-filled.svg';
import Minus from '@/public/img/icons/harmonized/minus.svg';
import MoonFilled from '@/public/img/icons/harmonized/moon-filled.svg';
import Moon from '@/public/img/icons/harmonized/moon.svg';
import More from '@/public/img/icons/harmonized/more.svg';
import OvercastFilled from '@/public/img/icons/harmonized/overcast-filled.svg';
import Overcast from '@/public/img/icons/harmonized/overcast.svg';
import PackageMinus from '@/public/img/icons/harmonized/package-minus.svg';
import PackagePlus from '@/public/img/icons/harmonized/package-plus.svg';
import Package from '@/public/img/icons/harmonized/package.svg';
import PartialCloudyFilled from '@/public/img/icons/harmonized/partial-cloudy-filled.svg';
import PartialCloudy from '@/public/img/icons/harmonized/partial-cloudy.svg';
import PauseCircle from '@/public/img/icons/harmonized/pause-circle.svg';
import PhoneFilled from '@/public/img/icons/harmonized/phone-filled.svg';
import Phone from '@/public/img/icons/harmonized/phone.svg';
import PiggyBank from '@/public/img/icons/harmonized/piggy-bank.svg';
import Placeholder from '@/public/img/icons/harmonized/placeholder.svg';
import PlaceholderFilled from '@/public/img/icons/harmonized/placeholder_filled.svg';
import ElectricalPlug from '@/public/img/icons/harmonized/plug.svg';
import PlusCircleFilled from '@/public/img/icons/harmonized/plus-circle-filled.svg';
import PlusCircle from '@/public/img/icons/harmonized/plus-circle.svg';
import PlusFilled from '@/public/img/icons/harmonized/plus-filled.svg';
import Plus from '@/public/img/icons/harmonized/plus.svg';
import Power from '@/public/img/icons/harmonized/power.svg';
import RainingFilled from '@/public/img/icons/harmonized/raining-filled.svg';
import Raining from '@/public/img/icons/harmonized/raining.svg';
import RefreshFilled from '@/public/img/icons/harmonized/refresh-filled.svg';
import Refresh from '@/public/img/icons/harmonized/refresh.svg';
import Scaffolding from '@/public/img/icons/harmonized/scaffolding.svg';
import ScreenRotationFilled from '@/public/img/icons/harmonized/screen-rotation-filled.svg';
import ScreenRotation from '@/public/img/icons/harmonized/screen-rotation.svg';
import Search from '@/public/img/icons/harmonized/search.svg';
import SecurityFilled from '@/public/img/icons/harmonized/security-filled.svg';
import Security from '@/public/img/icons/harmonized/security.svg';
import SendFilled from '@/public/img/icons/harmonized/send-filled.svg';
import Send from '@/public/img/icons/harmonized/send.svg';
import SettingsFilled from '@/public/img/icons/harmonized/settings-filled.svg';
import Settings from '@/public/img/icons/harmonized/settings.svg';
import ShareAndroidFilled from '@/public/img/icons/harmonized/share-android-filled.svg';
import ShareAndroid from '@/public/img/icons/harmonized/share-android.svg';
import ShareIosFilled from '@/public/img/icons/harmonized/share-ios-filled.svg';
import ShareIos from '@/public/img/icons/harmonized/share-ios.svg';
import ShoppingBagFilled from '@/public/img/icons/harmonized/shopping-bag-filled.svg';
import ShoppingBag from '@/public/img/icons/harmonized/shopping-bag.svg';
import ShoppingCartFilled from '@/public/img/icons/harmonized/shopping-cart-filled.svg';
import ShoppingCart from '@/public/img/icons/harmonized/shopping-cart.svg';
import SleetFilled from '@/public/img/icons/harmonized/sleet-filled.svg';
import Sleet from '@/public/img/icons/harmonized/sleet.svg';
import SmartMeter from '@/public/img/icons/harmonized/smart-meter.svg';
import SnowingFilled from '@/public/img/icons/harmonized/snowing-filled.svg';
import Snowing from '@/public/img/icons/harmonized/snowing.svg';
import SolarPowerFilled from '@/public/img/icons/harmonized/solar-power-filled.svg';
import SolarPower from '@/public/img/icons/harmonized/solar-power.svg';
import StopwatchFilled from '@/public/img/icons/harmonized/stopwatch-filled.svg';
import Stopwatch from '@/public/img/icons/harmonized/stopwatch.svg';
import SunFilled from '@/public/img/icons/harmonized/sun-filled.svg';
import Sun from '@/public/img/icons/harmonized/sun.svg';
import SunriseFilled from '@/public/img/icons/harmonized/sunrise-filled.svg';
import Sunrise from '@/public/img/icons/harmonized/sunrise.svg';
import SunsetFilled from '@/public/img/icons/harmonized/sunset-filled.svg';
import Sunset from '@/public/img/icons/harmonized/sunset.svg';
import ThermostatFilled from '@/public/img/icons/harmonized/thermostat-filled.svg';
import Thermostat from '@/public/img/icons/harmonized/thermostat.svg';
import ThunderstormFilled from '@/public/img/icons/harmonized/thunderstorm-filled.svg';
import Thunderstorm from '@/public/img/icons/harmonized/thunderstorm.svg';
import ToolFilled from '@/public/img/icons/harmonized/tool-filled.svg';
import Tool from '@/public/img/icons/harmonized/tool.svg';
import TrashFilled from '@/public/img/icons/harmonized/trash-filled.svg';
import Trash from '@/public/img/icons/harmonized/trash.svg';
import TrendUpFilled from '@/public/img/icons/harmonized/trend-up-filled.svg';
import TrendUp from '@/public/img/icons/harmonized/trend-up.svg';
import TrendingDownFilled from '@/public/img/icons/harmonized/trending-down-filled.svg';
import TrendingDown from '@/public/img/icons/harmonized/trending-down.svg';
import TrendingUpFilled from '@/public/img/icons/harmonized/trending-up-filled.svg';
import TrendingUp from '@/public/img/icons/harmonized/trending-up.svg';
import UserCircleFilled from '@/public/img/icons/harmonized/user-circle-filled.svg';
import UserCircle from '@/public/img/icons/harmonized/user-circle.svg';
import WeatherUndeterminedFilled from '@/public/img/icons/harmonized/weather-undetermined-filled.svg';
import WeatherUndetermined from '@/public/img/icons/harmonized/weather-undetermined.svg';
import WindyFilled from '@/public/img/icons/harmonized/windy-filled.svg';
import Windy from '@/public/img/icons/harmonized/windy.svg';
import XCircle from '@/public/img/icons/harmonized/x-circle.svg';
import XCloseFilled from '@/public/img/icons/harmonized/x-close-filled.svg';
import XClose from '@/public/img/icons/harmonized/x-close.svg';
import ZapCircleFilled from '@/public/img/icons/harmonized/zap-circle-filled.svg';
import ZapCircle from '@/public/img/icons/harmonized/zap-circle.svg';
import ZapFilled from '@/public/img/icons/harmonized/zap-filled.svg';
import ZapSquareFilled from '@/public/img/icons/harmonized/zap-square-filled.svg';
import ZapSquare from '@/public/img/icons/harmonized/zap-square.svg';
import Zap from '@/public/img/icons/harmonized/zap.svg';
import React from 'react';

type SvgIcon = React.FC<React.SVGProps<SVGSVGElement>>;

const svgIconMap = <T extends Record<string, unknown>>(icons: T) =>
  icons as { [K in keyof T]: SvgIcon };

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export const harmonizedIcons = svgIconMap({
  AlertCircleFilled,
  AlertCircle,
  AlertTriangleFilled,
  AlertTriangle,
  Airconditioner,
  ArrowCircleDownFilled,
  ArrowCircleDown,
  ArrowCircleLeftFilled,
  ArrowCircleLeft,
  ArrowCircleRightFilled,
  ArrowCircleRight,
  ArrowCircleUpFilled,
  ArrowCircleUp,
  ArrowLeft,
  ArrowRight,
  BatteryChargingFilled,
  BatteryCharging,
  BatteryEmptyFilled,
  BatteryEmpty,
  BatteryFullFilled,
  BatteryFull,
  BatteryLowFilled,
  BatteryLow,
  BatteryMidFilled,
  BatteryMid,
  BellFilled,
  BellPlusFilled,
  BellPlus,
  Bell,
  CalendarFilled,
  Calendar,
  CheckCircleFilled,
  CheckCircle,
  CheckFilled,
  Check,
  ChevronDownFilled,
  ChevronDown,
  ChevronLeftFilled,
  ChevronLeft,
  ChevronRightFilled,
  ChevronRight,
  ChevronSelectorVerticalFilled,
  ChevronSelectorVertical,
  ChevronUpFilled,
  ChevronUp,
  ClockFilled,
  Clock,
  CloudFilled,
  Cloud,
  CoinsStackedFilled,
  CoinsStacked,
  CompareFilled,
  Compare,
  CopyFilled,
  Copy,
  DeveloperFilled,
  Developer,
  Dot,
  DownloadFilled,
  Download,
  DrizzleFilled,
  Drizzle,
  EditFilled,
  Edit,
  EuroCircleFilled,
  EuroCircle,
  EuroFilled,
  Euro,
  EVFilled,
  EV,
  EyeFilled,
  EyeOffFilled,
  EyeOff,
  Eye,
  FileCheckFilled,
  FileCheck,
  FileSearchFilled,
  FileSearch,
  FilterLinesFilled,
  FilterLines,
  FoggyFilled,
  Foggy,
  FreezingRainFilled,
  FreezingRain,
  FullscreenExitFilled,
  FullscreenExit,
  FullscreenFilled,
  Fullscreen,
  GlobeFilled,
  Globe,
  GrabberFilled,
  Grabber,
  GridFilled,
  Grid,
  HeartFilled,
  HeartHand,
  Heart,
  HeartbeatAi,
  HeartbeatFilled,
  Heartbeat,
  HeatPump,
  HeatWaveFilled,
  HeatWave,
  HelpCircleFilled,
  HelpCircle,
  HomeLineFilled,
  HomeLine,
  IconOutlined,
  InfoCircleFilled,
  InfoCircle,
  LightCloudsNightFilled,
  LightCloudsNight,
  LineChartUpFilled,
  LineChartUp,
  LinkExternalFilled,
  LinkExternal,
  LinkFilled,
  Link,
  LogOutFilled,
  LogOut,
  MailFilled,
  Mail,
  MenuFilled,
  Menu,
  MessageQuestionCircleFilled,
  MessageQuestionCircle,
  MinusFilled,
  Minus,
  MoonFilled,
  Moon,
  More,
  OvercastFilled,
  Overcast,
  PartialCloudyFilled,
  PartialCloudy,
  Package,
  PackageMinus,
  PackagePlus,
  PauseCircle,
  PhoneFilled,
  Phone,
  PiggyBank,
  PlaceholderFilled,
  Placeholder,
  PlusCircleFilled,
  PlusCircle,
  PlusFilled,
  Plus,
  ElectricalPlug,
  Power,
  RainingFilled,
  Raining,
  RefreshFilled,
  Refresh,
  Scaffolding,
  ScreenRotationFilled,
  ScreenRotation,
  Search,
  SecurityFilled,
  Security,
  SendFilled,
  Send,
  SettingsFilled,
  Settings,
  ShareAndroidFilled,
  ShareAndroid,
  ShareIosFilled,
  ShareIos,
  ShoppingBagFilled,
  ShoppingBag,
  ShoppingCartFilled,
  ShoppingCart,
  SleetFilled,
  Sleet,
  SmartMeter,
  SnowingFilled,
  Snowing,
  SolarPowerFilled,
  SolarPower,
  StopwatchFilled,
  Stopwatch,
  SunFilled,
  Sun,
  SunriseFilled,
  Sunrise,
  SunsetFilled,
  Sunset,
  ThermostatFilled,
  Thermostat,
  ThunderstormFilled,
  Thunderstorm,
  ToolFilled,
  Tool,
  TrashFilled,
  Trash,
  TrendUpFilled,
  TrendUp,
  TrendingDownFilled,
  TrendingDown,
  TrendingUpFilled,
  TrendingUp,
  UserCircleFilled,
  UserCircle,
  WeatherUndeterminedFilled,
  WeatherUndetermined,
  WindyFilled,
  Windy,
  XCircle,
  XCloseFilled,
  XClose,
  ZapCircleFilled,
  ZapCircle,
  ZapFilled,
  ZapSquareFilled,
  ZapSquare,
  Zap,
});

export const customIcons = svgIconMap({
  AdditionalWork,
  Inverter,
  Camera,
  CellsAndHouse,
  Customers,
  DotsVertical,
  NavGrid,
  Pin,
  User,
  RefreshTwo,
  Star,
  Factory,
  Lightning,
  Loading,
  MoneyLoss,
  MoneyProfit,
  Plug,
  Tree,
  Van,
  CalendarDk,
  Computer,
  Document,
  SelfSufficiency,
  Support,
  SettingsAlt,
  BarChart,
});
/* eslint-enable @typescript-eslint/no-unsafe-assignment */

const icons = {
  ...harmonizedIcons,
  ...customIcons,
};

export type IconName = keyof typeof icons;

type Animation = 'spin';
const animationMap: Record<Animation, string> = {
  spin: 'animate-spin',
};

export const Icon = ({
  className = '',
  icon,
  animation,
}: {
  className?: string;
  icon: IconName;
  animation?: Animation;
}) => {
  const IconComponent = icons[icon];
  const shouldSpin = animation === 'spin' || icon === 'Loading';
  const animationClass = shouldSpin
    ? animationMap.spin
    : animation && animationMap[animation];
  return <IconComponent className={cn(animationClass, className)} />;
};
